<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>アカウント詳細</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" :replaceList="errMessageReplaceList" message-key="message.admin.account.error."/>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>ID</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>{{ view.mailAddress }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>パスワード</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-checkbox
            dense
            class="mt-0 pt-0"
            v-model="form.passwordResetFlg"
            label="パスワードをリセットする"
            id="passwordResetFlg"
            :disabled="!view.isEditable"
          ></v-checkbox>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>氏名</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.name"
            v-bind:placeholder="$t('message.admin.account.ph.name')"
            id="name"
            hide-details
            solo
            maxlength="50"
            required
            validate-on-blur
            :disabled="!view.isEditable"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>所属</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.groupLarge.groupLargeName.ja }}<span class="mx-2">＞</span>{{
          view.groupSmall.groupSmallName.ja }}
        </mp-input-box>
        <mp-input-box>
          <v-select
            v-if="view.groupSmall.adminUpdFlg === '1'"
            v-model="form.groupSmallId"
            :items="view.groupSmallList"
            item-text="text"
            item-value="value"
            label="所属グループ（小分類）を変更する場合は選択してください"
            hide-details
            solo
            dense
            color="green"
            item-color="green"
            @change="changeGroupSmall"
            :disabled="!view.isEditable"
          ></v-select>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{view.companyLabel.ja}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-select
            v-model="form.companyId"
            :items="view.companyList"
            :label="$t('message.admin.account.ph.companyId')"
            item-text="companyName"
            item-value="companyId"
            :disabled="view.companyList.length === 0 || form.companyInsNoFlg === '1' || !view.isEditable"
            id="companyId"
            hide-details
            solo
            dense
            @change="changeCompany"
          ></v-select>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{view.branchLabel.ja}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-select
            v-model="form.branchId"
            :items="view.branchList"
            :label="$t('message.admin.account.ph.branch').replace('##BRANCH_LABEL##', view.branchLabel.ja)"
            item-text="branchName"
            item-value="branchId"
            :disabled="view.branchList.length === 0 || form.companyInsNoFlg === '1' || !view.isEditable"
            id="branchId"
            hide-details
            solo
            dense
          ></v-select>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>郵便番号</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.postNo"
            hide-details
            v-bind:placeholder="$t('message.admin.account.ph.postNo')"
            id="postNo"
            solo
            dense
            maxlength="20"
            :disabled="!view.isEditable"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>都道府県</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-select
            v-model="form.prefCd"
            :items="$store.getters.prefCodeList"
            :item-text="getPrefName"
            item-value="kbnCd"
            :label="$t('message.admin.account.ph.prefCd')"
            id="prefCd"
            hide-details
            dense
            solo
            :disabled="!view.isEditable"
          ></v-select>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>市区町村</mp-label>
      </v-col>
      <v-col cols="8" dense>
        <mp-input-box>
          <v-text-field
            v-model="form.addr1"
            v-bind:placeholder="$t('message.admin.account.ph.addr1')"
            id="addr1"
            hide-details
            dense
            solo
            maxlength="100"
            :disabled="!view.isEditable"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>番地</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.addr2"
            v-bind:placeholder="$t('message.admin.account.ph.addr2')"
            id="addr2"
            hide-details
            dense
            solo
            maxlength="100"
            :disabled="!view.isEditable"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>ビル名</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.addr3"
            v-bind:placeholder="$t('message.admin.account.ph.addr3')"
            id="addr3"
            hide-details
            dense
            solo
            maxlength="100"
            :disabled="!view.isEditable"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>部署</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.busho"
            v-bind:placeholder="$t('message.admin.account.ph.busho')"
            id="busho"
            hide-details
            dense
            solo
            maxlength="100"
            :disabled="!view.isEditable"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>電話番号</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.telNo"
            v-bind:placeholder="$t('message.admin.account.ph.telNo')"
            id="telNo"
            hide-details
            dense
            solo
            maxlength="20"
            :disabled="!view.isEditable"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <!-- 備考 -->
    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>備考</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-textarea
            v-model="form.remarks"
            v-bind:placeholder="$t('message.admin.account.ph.remarks')"
            id="remarks"
            hide-details
            dense
            solo
            maxlength="20000"
            :disabled="!view.isEditable"
          ></v-textarea>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>利用希望サービス</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-checkbox v-for="(item) in view.serviceList"
            :key="item.serviceId"
            v-model="form.services"
            :value="item.serviceId"
            :id="`serviceId-${item.serviceId}`"
            :disabled="!(item.groupLargeIdList.includes(view.groupLargeId) && item.groupSmallIdList.includes(form.groupSmallId)) || !view.userServices.includes(item.serviceId) || isInoperableEntryStatus(item.serviceId) || !view.isEditable"
            hide-details
            dense
            class="my-2 py-0"
          >
            <template v-slot:label>
                {{ item.serviceName.ja }}
                <span v-if="isDisplayableEntryStatus(item.serviceId)">&nbsp;【{{ $t("message.code.entryStatus." + getEntryStatus(item.serviceId)) }}】</span>
            </template>
          </v-checkbox>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>責任者設定</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-checkbox
            dense
            class="mt-0 pt-0"
            v-model="form.groupAdminFlg"
            label="グループ責任者に設定する"
            id="groupAdminFlg"
            :disabled="form.companyInsNoFlg === '1' || !view.isEditable"
          ></v-checkbox>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>一時停止設定</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-checkbox
            dense
            class="mt-0 pt-0"
            v-model="form.tempStopFlg"
            label="アカウントを一時的に利用停止に設定する"
            id="tempStopFlg"
            :disabled="!view.isEditable"
          ></v-checkbox>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>管理者設定</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-checkbox
            dense
            class="mt-0 pt-0"
            v-model="form.adminFlg"
            label="管理者として設定する"
            id="adminFlg"
            @change="changeAdmin"
            :disabled="!view.isEditable"
          ></v-checkbox>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>メール設定</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-checkbox
            dense
            class="mt-0 pt-0"
            v-model="form.accountReltnMailRcvFlg"
            label="アカウント関連のメールを受信する"
            id="accountReltnMailRcvFlg"
            :disabled="!form.adminFlg || !view.isEditable"
          ></v-checkbox>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="12" md="6" offset-md="2">
        <mp-input-box>
          <v-checkbox
            dense
            class="mt-0 pt-0"
            v-model="form.forceChangeFlg"
            label="責任者不在になっても強制的に変更する"
            id="forceChangeFlg"
            :disabled="form.companyInsNoFlg === '1' || !view.isEditable"
          ></v-checkbox>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goList">戻る</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button
          wide
          @click="goModify"
          :disabled="!view.isEditable"
          :disabledBtn="!view.isEditable"
        >
          変更を保存する
        </mp-button>
        <mp-dialog modify :show="dialog.modifyComplete" @clickOk="goList"/>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{ $t('message.admin.account.title.delete') }}</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <div>
          {{ $t('message.admin.account.desc.delete.text1') }}
        </div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="8"
        md="4"
      >
        <div>
          <mp-button
            red
            wide
            @click.stop="dialog.deleteConfirm = true"
            :disabled="!view.isEditable"
            :disabledBtn="!view.isEditable"
          >
            {{ $t('message.admin.account.button.delete') }}
          </mp-button>
        </div>
        <mp-dialog delete confirm :show="dialog.deleteConfirm" @clickOk="goDelete"
                   @clickCancel="dialog.deleteConfirm = false"/>
        <mp-dialog delete :show="dialog.deleteComplete" @clickOk="goList"/>
      </v-col>
    </v-row>

    <!-- フリーランス申請詳細 start -->
    <template v-if="view.entryFreelance">
      <v-row justify="center">
        <v-col cols="12">
          <h1 class="mt-5">フリーランス申請</h1>
        </v-col>
      </v-row>

      <!-- 推薦媒社名 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>推薦媒社名</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-input-box>{{ view.entryFreelance.recommendationCompanyName }}</mp-input-box>
        </v-col>
      </v-row>

      <!-- 推薦媒体名 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>推薦媒体名</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-input-box>{{ view.entryFreelance.recommendationMediaName }}</mp-input-box>
        </v-col>
      </v-row>

      <!-- 媒体内容 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>媒体内容</mp-label>
        </v-col>
        <v-col cols="8" class="pr-0">
          <mp-multiple-lines-input-box>{{ view.entryFreelance.mediaContents }}</mp-multiple-lines-input-box>
        </v-col>
      </v-row>

      <!-- 媒体発行詳細 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>媒体発行詳細</mp-label>
        </v-col>
        <v-col cols="8" class="pr-0">
          <mp-multiple-lines-input-box>{{ view.entryFreelance.mediaIssueDetail }}</mp-multiple-lines-input-box>
        </v-col>
      </v-row>

      <!-- 推薦責任者名 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>推薦責任者名</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-input-box>{{ view.entryFreelance.recommendationResponsibleName }}</mp-input-box>
        </v-col>
      </v-row>

      <!-- 推薦責任者メールアドレス -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>推薦責任者メールアドレス</mp-label>
        </v-col>
        <v-col cols="8">
          <mp-input-box>{{ view.entryFreelance.recommendationResponsibleMailAddress }}</mp-input-box>
        </v-col>
      </v-row>

      <!-- 推薦理由 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>推薦理由</mp-label>
        </v-col>
        <v-col cols="8" class="pr-0">
          <mp-multiple-lines-input-box>{{ view.entryFreelance.recommendationReason }}</mp-multiple-lines-input-box>
        </v-col>
      </v-row>

      <!-- 取材活動実績 -->
      <v-row justify="center" dense>
        <v-col cols="4">
          <mp-label>取材活動実績</mp-label>
        </v-col>
        <v-col cols="8" class="pr-0">
          <div>
            <mp-multiple-lines-input-box>{{ view.entryFreelance.trackRecord }}</mp-multiple-lines-input-box>
          </div>
          <div class="my-3">
            <div class="px-2" v-for="file in view.entryFreelance.files" :key="file.url"><a :href="file.url">{{ file.name }}</a></div>
          </div>
        </v-col>
      </v-row>

    </template>
    <!-- フリーランス申請詳細 end -->

    <!-- ローカル媒体申請 start -->
    <v-row v-if="view.entryLocalMediaList.length" justify="center">
        <v-col cols="12">
          <h1 class="mt-5">ローカル媒体申請</h1>
        </v-col>
    </v-row>

    <div>
      <div class="entry-local-media" v-for="entryLocalMedia in view.entryLocalMediaList" :key="entryLocalMedia.accountEntryId">
        <!-- 申請者氏名 -->
        <v-row justify="center" dense>
          <v-col cols="4">
            <mp-label>申請者氏名</mp-label>
          </v-col>
          <v-col cols="8">
            <mp-input-box>{{ entryLocalMedia.applicantName }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 媒体発行詳細 -->
        <v-row justify="center" dense>
          <v-col cols="4">
            <mp-label>媒体発行詳細</mp-label>
          </v-col>
          <v-col cols="8">
            <mp-multiple-lines-input-box>{{ entryLocalMedia.mediaIssueDetail }}</mp-multiple-lines-input-box>
          </v-col>
        </v-row>

        <!-- 媒体カバーエリア -->
        <v-row justify="center" dense>
          <v-col cols="4">
            <mp-label>媒体カバーエリア</mp-label>
          </v-col>
          <v-col cols="8">
            <mp-multiple-lines-input-box>{{ entryLocalMedia.mediaCoverageArea }}</mp-multiple-lines-input-box>
          </v-col>
        </v-row>

        <!-- グループ責任者名 -->
        <v-row justify="center" dense>
          <v-col cols="4">
            <mp-label>グループ責任者名</mp-label>
          </v-col>
          <v-col cols="8">
            <mp-input-box>{{ entryLocalMedia.groupResponsibleName }}</mp-input-box>
          </v-col>
        </v-row>

        <!-- 利用者名 -->
        <v-row justify="center" dense>
          <v-col cols="4">
            <mp-label>利用者名</mp-label>
          </v-col>
          <v-col cols="8">
            <mp-multiple-lines-input-box>{{ entryLocalMedia.userName }}</mp-multiple-lines-input-box>
          </v-col>
        </v-row>

        <!-- ローカル媒体管理クラブ-->
        <v-row justify="center" dense>
          <v-col cols="4">
            <mp-label>ローカル媒体管理クラブ</mp-label>
          </v-col>
          <v-col cols="8">
            <p v-for="clubCode in entryLocalMedia.localMediaManagementClub" :key="clubCode">{{ $store.getters.localMediaManagementClubNameByCode(clubCode).ja }}</p>
          </v-col>
        </v-row>

        <!-- その他 -->
        <v-row justify="center" dense>
          <v-col cols="4">
            <mp-label>その他</mp-label>
          </v-col>
          <v-col cols="8">
            <mp-multiple-lines-input-box>{{ entryLocalMedia.other }}</mp-multiple-lines-input-box>
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- ローカル媒体申請 end -->

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import { AdminAccount, Common } from '@/api'
import MpError from '@/components/item/MpError'
import StringUtils from '@/utils/StringUtil'
import MpMultipleLinesInputBox from '@/components/item/MpMultipleLinesInputBox.vue'

export default {
  name: 'top',
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton,
    MpDialog,
    MpMultipleLinesInputBox
  },
  data: () => ({
    accountId: '',
    view: {
      isEditable: false,
      errors: [],
      companyDefaultLabel: {
        ja: ''
      },
      branchDefaultLabel: {
        ja: ''
      },
      companyLabel: {
        ja: ''
      },
      branchLabel: {
        ja: ''
      },
      groupSmallList: [],
      groupSmall: {
        adminUpdFlg: '',
        groupSmallName: {
          ja: '',
          en: ''
        }
      },
      groupLarge: {
        companyInsNoFlg: '',
        groupLargeName: {
          ja: '',
          en: ''
        }
      },
      companyList: [],
      branchList: [],
      serviceList: [],
      accountId: '',
      mailAddress: '',
      name: '',
      companyId: '',
      branchId: '',
      postNo: '',
      prefCd: '',
      addr1: '',
      addr2: '',
      addr3: '',
      busho: '',
      telNo: '',
      remarks: '',
      services: [],
      userServices: [],
      serviceApplications: [],
      groupLargeId: null,
      groupSmallId: null,
      groupAdminFlg: null,
      adminFlg: null,
      tempStopFlg: null,
      accountReltnMailRcvFlg: null,
      entryFreelance: null,
      entryLocalMediaList: []
    },
    form: {
      name: '',
      companyInsNoFlg: '',
      companyId: '',
      branchId: '',
      postNo: '',
      prefCd: '',
      addr1: '',
      addr2: '',
      addr3: '',
      busho: '',
      telNo: '',
      remarks: '',
      services: [],
      passwordResetFlg: null,
      groupSmallId: null,
      groupAdminFlg: null,
      tempStopFlg: null,
      adminFlg: null,
      accountReltnMailRcvFlg: null,
      forceChangeFlg: null
    },
    dialog: {
      modifyComplete: false,
      deleteConfirm: false,
      deleteComplete: false
    },
    errMessageReplaceList: []
  }),
  computed: {},
  methods: {
    initCompanyList () {
      this.view.companyList = []
      this.form.companyId = null
    },
    initBranchList () {
      this.view.branchList = []
      this.form.branchId = null
    },
    initServiceList () {
      this.form.services = []
    },
    changeGroupSmall (groupSmallId) {
      // サービス、会社および支社・支局を初期化
      this.initServiceList()
      this.initBranchList()
      this.initCompanyList()
      this.setCompanyAndBranchLabel(groupSmallId)

      // 現在のサービスが含まれていればセット
      this.setCurrentServices(this.view.groupLarge.groupLargeId, groupSmallId)

      // 会社情報を設定
      if (this.form.companyInsNoFlg === '0') {
        this.getCompanyList(groupSmallId).then(() => {
          // 現在の会社が含まれていればセット
          this.setCurrentCompany()
        })
      }
    },
    setCompanyAndBranchLabel (groupSmallId) {
      const groupSmall = this.view.groupSmallList
        .find(groupSmall => groupSmall.value === Number(groupSmallId))

      if (groupSmall === undefined) {
        this.view.companyLabel.ja = this.view.companyDefaultLabel.ja
        this.view.branchLabel.ja = this.view.branchDefaultLabel.ja
      } else {
        this.view.companyLabel.ja = StringUtils.isEmpty(groupSmall.companyLabel.ja) ? this.view.companyDefaultLabel.ja : groupSmall.companyLabel.ja
        this.view.branchLabel.ja = StringUtils.isEmpty(groupSmall.branchLabel.ja) ? this.view.branchDefaultLabel.ja : groupSmall.branchLabel.ja
      }
    },
    getPrefName (item) {
      return item.kbnVal.ja
    },
    setCurrentServices (groupLargeId, groupSmallId) {
      for (const item of this.view.serviceList) {
        if (item.groupLargeIdList.includes(groupLargeId) && item.groupSmallIdList.includes(groupSmallId)) {
          if (this.view.services.includes(item.serviceId)) {
            this.form.services.push(item.serviceId)
          }
        }
      }
    },
    setCurrentCompany () {
      if (this.view.companyList.length === 0) {
        return
      }
      if (this.view.companyList.find((item) => item.companyId === this.view.companyId)) {
        this.form.companyId = this.view.companyId
        this.changeCompany(this.form.companyId)
      }
    },
    async getCompanyList (groupSmallId) {
      // 返却用のリスト準備
      this.view.companyList = await Common.companyList({ groupSmallId: groupSmallId })
    },
    changeCompany (companyId) {
      // 会社の一部と支社・支局を初期化
      this.initBranchList()

      // 支社・支局の一覧をセット
      this.getBranchList(companyId).then(() => {
        // 現在の支社・支局が含まれていればセット
        this.setCurrentBranch()
      })
    },
    setCurrentBranch () {
      if (this.view.branchList.length === 0) {
        return
      }
      if (this.view.branchList.find((item) => item.branchId === this.view.branchId)) {
        this.form.branchId = this.view.branchId
      }
    },
    async getBranchList (companyId) {
      // 返却用のリスト準備
      this.view.branchList = await Common.branchList({ companyId: companyId })
    },
    goList () {
      this.$router.push({ path: '/admin/account/list' })
    },
    goLogout () {
      this.$store.dispatch('logout')
        .then(this.$router.push({ path: '/auth/login' }))
    },
    async goModify () {
      await AdminAccount.update({
        accountId: this.accountId,
        name: this.form.name,
        companyInsNoFlg: this.form.companyInsNoFlg,
        companyId: this.form.companyId,
        branchId: this.form.branchId,
        postNo: this.form.postNo,
        prefCd: this.form.prefCd,
        addr1: this.form.addr1,
        addr2: this.form.addr2,
        addr3: this.form.addr3,
        busho: this.form.busho,
        telNo: this.form.telNo,
        remarks: this.form.remarks,
        services: this.form.services,
        passwordResetFlg: this.form.passwordResetFlg,
        groupSmallId: this.form.groupSmallId,
        groupAdminFlg: this.form.groupAdminFlg ? '1' : '0',
        tempStopFlg: this.form.tempStopFlg ? '1' : '0',
        adminFlg: this.form.adminFlg ? '1' : '0',
        accountReltnMailRcvFlg: this.form.accountReltnMailRcvFlg ? '1' : '0',
        forceChangeFlg: this.form.forceChangeFlg
      })
        .then(() => {
          // 自身のアカウントを一時停止した場合は処理完了時に強制ログアウトする。
          if (this.accountId === this.$store.state.auth.userId) {
            this.goLogout()
          }
          this.dialog.modifyComplete = true
        })
        .catch(error => {
          this.view.errors = error.messages
        })
    },
    async goDelete () {
      // ダイアログ非表示
      this.dialog.deleteConfirm = false

      await AdminAccount.delete({ accountId: this.accountId })
        .then(() => {
          this.dialog.deleteComplete = true
          // 自身のアカウントを削除した場合は処理完了時に強制ログアウトする。
          if (this.accountId === this.$store.state.auth.userId) {
            this.goLogout()
          }
        })
        .catch(error => {
          this.view.errors = error.messages
        })
    },
    changeAdmin (adminFlg) {
      if (!adminFlg && this.form.accountReltnMailRcvFlg) {
        this.form.accountReltnMailRcvFlg = !this.form.accountReltnMailRcvFlg
      }
    },
    async setDefaultLabel () {
      const list = await Common.labelList({ key: 'default' })
      this.view.companyLabel.ja = this.view.companyDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.company.ja')
      this.view.branchLabel.ja = this.view.branchDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.branch.ja')
    },
    getDefaultLabelFromList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      }
      return ele.configVal
    },
    setErrMessageReplaceList () {
      this.errMessageReplaceList = [
        { param: 'companyId', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'companyName', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'companyNameKana', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'branchId', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel },
        { param: 'branchName', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel },
        { param: 'branchNameKana', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel }
      ]
    },
    isInoperableEntryStatus (serviceId) {
      const serviceApp = this.getServiceApplication(serviceId)
      if (serviceApp) {
        return serviceApp.entryStatus === '1'
      } else {
        return false
      }
    },
    isDisplayableEntryStatus (serviceId) {
      const serviceApp = this.getServiceApplication(serviceId)
      if (serviceApp) {
        return serviceApp.entryStatus === '1'
      } else {
        return false
      }
    },
    getEntryStatus (serviceId) {
      const serviceApp = this.getServiceApplication(serviceId)
      if (serviceApp) {
        return serviceApp.entryStatus
      } else {
        return ''
      }
    },
    getServiceApplication (serviceId) {
      return this.view.serviceApplications.find((v) => {
        return serviceId === v.serviceId
      })
    }
  },
  created: async function () {
    // パラメータからアカウントIDを取得
    this.accountId = this.$route.params.id

    // アカウント情報取得AdminAccount
    const result = await AdminAccount.detail({ accountId: this.accountId })
      .catch(error => {
        this.view.errors = error.messages
      })
    this.view = { ...this.view, ...result }

    // 小分類のリスト
    this.view.groupSmallList = (await Common.groupList())
      .find(groupLarge => groupLarge.groupLargeId === this.view.groupLarge.groupLargeId).groupSmallList
      .map(groupSmall => ({
        text: groupSmall.groupSmallName.ja,
        value: groupSmall.groupSmallId,
        companyLabel: groupSmall.companyLabel,
        branchLabel: groupSmall.branchLabel
      }))

    // サービスリスト
    this.view.serviceList = await Common.serviceList()

    this.form = {
      name: this.view.name,
      companyInsNoFlg: this.view.groupLarge.companyInsNoFlg,
      groupSmallId: this.view.groupSmall.groupSmallId,
      companyId: this.view.companyId,
      branchId: this.view.branchId,
      postNo: this.view.postNo,
      prefCd: this.view.prefCd,
      addr1: this.view.addr1,
      addr2: this.view.addr2,
      addr3: this.view.addr3,
      busho: this.view.busho,
      telNo: this.view.telNo,
      remarks: this.view.remarks,
      services: this.view.services,
      groupAdminFlg: this.view.groupAdminFlg === '1',
      tempStopFlg: this.view.tempStopFlg === '1',
      adminFlg: this.view.adminFlg === '1',
      accountReltnMailRcvFlg: this.view.accountReltnMailRcvFlg === '1'
    }

    // 会社・支社ラベル
    await this.setDefaultLabel()
    this.setErrMessageReplaceList()

    // 初期表示
    this.changeGroupSmall(this.form.groupSmallId)
  }
}
</script>

<style scoped>
  .v-messages {
    min-height: 0 !important;
  }
  .entry-local-media:not(:first-of-type){
    margin-top: 25px;
    padding-top: 25px;
    border-top: 1px solid #E62233;
  }
</style>
